import { AssessorLayout } from '@layouts/AssessorLayout/AssessorLayout';
import { RegistrationsTable } from '@components/assessors/organisms/RegistrationsTable/RegistrationsTable';
import { Container } from '@layouts/Container/Container';

import styles from './RegistrationsPage.module.scss';

export default function RegistrationsPage() {
  return (
    <AssessorLayout>
      <div className={styles.registrationsPage}>
        <Container>
          <RegistrationsTable />
        </Container>
      </div>
    </AssessorLayout>
  );
}
